<template>
  <el-card>
    <div slot="header">
      Vevőadatok
    </div>
    <el-form
      ref="customerDataForm"
      :model="customerData"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Fizetési módok">
            <el-select
              v-model="customerData.payment_methods"
              multiple
              style="width: 100%"
              value-key="id"
            >
              <el-option
                v-for="paymentMethod in paymentMethods"
                :key="paymentMethod.id"
                :label="paymentMethod.name"
                :value="paymentMethod.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Fizetési határidő">
            <el-input
              v-model.number="customerData.payment_deadline"
            >
              <template slot="append">
                nap
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="display: flex; align-items: center;">
        <el-col :span="12">
          <el-form-item label="Számla nyelve">
            <el-select
              v-model="customerData.invoice_language"
              style="width: 100%"
            >
              <el-option
                label="Magyar"
                value="hu"
              />
              <el-option
                label="Angol"
                value="en"
              />
              <el-option
                label="Német"
                value="de"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="is_order_id_required"
            style="margin-bottom: 0;"
          >
            <el-checkbox v-model="customerData.is_order_id_required">
              Megrendelésszám kötelező
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="Típus">
            <el-checkbox v-model="customerData.is_wholesale">
              Nagykereskedő
            </el-checkbox>
            <el-checkbox v-model="customerData.is_regular_customer">
              Törzsvásárló
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
  export default {
    props: ['partner'],
    data() {
      return {
        customerData: {
          payment_method: null,
          payment_deadline: null,
          is_wholesale: false,
          is_regular_customer: false,
          invoice_language: 'hu',
          is_order_id_required: false,
        },
      };
    },
    computed: {
      paymentMethods() {
        return this.$store.getters['paymentMethod/paymentMethods'];
      },
    },
    watch: {
      partner(newVal) {
        this.customerData = {
          payment_methods: newVal.payment_methods ? newVal.payment_methods.map(s => s.id) : [],
          payment_deadline: newVal.company.payment_deadline,
          is_wholesale: newVal.company.is_wholesale,
          is_regular_customer: newVal.company.is_regular_customer,
          invoice_language: newVal.company.invoice_language,
          is_order_id_required: newVal.partner.is_order_id_required,
        };
      },
    },
    mounted() {
      this.customerData = {
        payment_methods: this.partner.payment_methods ? this.partner.payment_methods.map(s => s.id) : [],
        payment_deadline: this.partner.company.payment_deadline,
        is_wholesale: this.partner.company.is_wholesale,
        is_regular_customer: this.partner.company.is_regular_customer,
        invoice_language: this.partner.company.invoice_language,
        is_order_id_required: this.partner.is_order_id_required,
      };
    },
  };
</script>
